import Main from './Main'
import Lista from './components/Reboquista'
import Novo from './components/NovoReboquista'

export default [
  {
    path: 'reboquista',
    name: 'config.reboquista',
    component: Main,
    redirect: { name: 'config.reboquista.list' },
    children: [
      {
        path: '/',
        name: 'config.reboquista.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.reboquista.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.reboquista.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/configuracoes/reboquista/routes.js